import { render, staticRenderFns } from "./VMyTasks.vue?vue&type=template&id=10c18812&"
import script from "./VMyTasks.vue?vue&type=script&lang=js&"
export * from "./VMyTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports